module.exports = __webpack_public_path__ + "static/1-003-7df56cb7eb347ee3d48757d8f02c69e4.png";